export enum PortfolioVersionType {
  /**
   * One of the 'Live' version types of a given portfolio. This version type is a snapshot view of the portfolio on a given date and may not be edited.
   *
   * A portfolio may have a Position version if:
   * - it is a Live Portfolio (see `isLivePortfolioFn`)
   * - or if it contains a Drop Zone Custom Weighting attribute
   *
   * This version type is visible on the following pages:
   * - Constituent Position
   * - Constituent Risk (position mode ONLY)
   */
  POSITION = 'Position',

  /**
   * One of the 'Live' version types of a given portfolio. This version type is a historical view of the portfolio and may not be edited.
   *
   * It consists of a flattened tree of all the strategies that have ever existed in this portfolio. It is created as a
   * custom weighting with `backtestDates` and `backtestWeights`, so that we can properly create a backtest of the reality.
   *
   * This version type is visible on the following pages:
   * - Portfolio Construction
   * - PCA
   * - Factor Decomposition
   * - Constituent Risk (history mode ONLY)
   * - Portfolio Factsheet
   */
  HISTORY = 'History',

  /**
   * A Simulation version of a given portfolio. This is the only version type that can be edited.
   */
  SIMULATION = 'Simulation',

  /**
   * A Provisional version of a given portfolio. This is a version that is not yet live, but is frozen
   * until it is approved. It essentially acts as a transition state between a Simulation and a Position version.
   */
  PROVISIONAL = 'Provisional',
}
